import { Component, inject, input, signal } from '@angular/core';
import { DropdownComponent } from '../../dropdown-component/dropdown-component';
import { MatDialog } from '@angular/material/dialog';
import { Management } from '../../dialogs/management/management';
import { Downtime } from '../../../../core/services/times/downtime';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-active-player',
  imports: [DropdownComponent, TranslatePipe],
  templateUrl: './active-player.html',
  styleUrl: './active-player.scss'
})
export class ActivePlayer {

  isOpenDropdown = signal<boolean>(false);

  players = input<any>();
  turning = input<number>(0);
  type = input();
  player = input<any>();
  uuid = input<string>();

  readonly dialog = inject(MatDialog);
  downtime = inject(Downtime);

  isTurning(player_id: number): boolean {
    return (player_id === (this.turning() as number));
  }

  showPlayerInfo(player_id: number) {
    this.downtime.refreshTimer();
    if (!this.player().is_starter) {
      this.isOpenDropdown.update(value => !value);
    }else{
      const dialogRef = this.dialog.open(Management,{data:{turning: this.turning(), uuid: this.uuid() }});
    }
  }

}
